import AModal from '@/components/A/AModal/AModal'
import styles from './DownloadPptRechargeModal.module.less'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { PAGE_LINKS } from '@/router/pageConst'
import { useTranslation } from 'react-i18next'
import MiddleText from '@/components/MiddleText/MiddleText'

function DownloadPptRechargeModal() {
  const { t } = useTranslation()
  const modal = useModal()
  return <AModal
    testId='download-ppt-recharge-modal'
    className={styles.downloadPptRechargeModal}
    open={modal.visible}
    onCancel={modal.hide}
    afterClose={() => {
      modal.remove()
    }}
    footer={null}
  >
    <div className={styles.downloadPptRechargeModalContent}>
      <p className={styles.title}>{t('modals.downloadPptRechargeModal.title')}</p>
      <p className={styles.desc}>{t('modals.downloadPptRechargeModal.desc1')}</p>
      <p className={styles.desc}>{t('modals.downloadPptRechargeModal.desc2')}</p>
      <button className={styles.btn} data-testid='download-ppt-recharge-btn' onClick={() => {
        modal.hide()
        window.open(PAGE_LINKS.pricing)
      }}>
        <span>🚀</span>
        <MiddleText text={t('modals.downloadPptRechargeModal.btn')}></MiddleText>
      </button>
    </div>
  </AModal>
}

export default NiceModal.create(DownloadPptRechargeModal)
